import HotelRooms from './HotelRooms.container';
export default HotelRooms;